import { render, staticRenderFns } from "./SvgLoader.vue?vue&type=template&id=2c9c1271&scoped=true&"
import script from "./SvgLoader.vue?vue&type=script&lang=js&"
export * from "./SvgLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c1271",
  null
  
)

export default component.exports